import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { FlexColumn } from 'ui-components/components/flex';

import messages from '../../messages';
import style from '../../style.module.less';

/**
 * @param {object} props
 * @param {string} props.message
 * @param {string} props.code
 * @returns {JSX.Element}
 */
const ErrorBanner = ({ message, code }) => {
  return (
    <FlexColumn className={style['error-wrapper']}>
      <BannerMessageV2 content={<FormattedMessage {...messages.errorMessage} values={{ message, code }} />} status={BannerStatus.Error} />
    </FlexColumn>
  );
};

export default ErrorBanner;
